import * as React from "react";

import styles from  "./underline-dropdown.module.css";

export type TUnderlineDropdownItem = {
	value: any; // could be a string or a number
	text: string;
};

export type TUnderlineDropdownProps = {
	name: string,
	value?: any,
	className?: string,
	options?: TUnderlineDropdownItem[],
	onChange?: (event: any) => void,
	isDisabled?: boolean,
	smallDropdown?: boolean,
	onMousedown?: (event: any) => void,
	onBlur?: (event: any) => void,
};

const UnderlineDropdown: React.FC<TUnderlineDropdownProps> =
	({ name, value, className, options, onChange, isDisabled, smallDropdown, onMousedown, onBlur}) => {

		if (className) {
			className += ` ${styles.underline_dropdown} mt-2`;
		} else {
			className = ` ${styles.underline_dropdown} mt-2`;
		}

		if (isDisabled) {
			className += " disabled";
		}

		if (smallDropdown) {
			className += ` ${styles.small_underline_dropdown}`;
		}

		return (
			<select
				name={name}
				value={value}
				onChange={onChange}
				onMouseDown={onMousedown}
				onBlur={onBlur}
				className={className}
				disabled={isDisabled}>
				{
					options.map((option) => (<option key={option.value} value={option.value}>{option.text}</option>))
				}
			</select>
		);
	};

export default UnderlineDropdown;